import { Input } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { FormItem } from '../FormItem';

interface PasswordInputI {
  name: string;
  label?: string;
  size?: SizeType;
  placeholder?: string;
  errorMessage?: string;
}

const PasswordInput = ({
  errorMessage,
  label = '',
  name,
  size = 'large',
  placeholder,
}: PasswordInputI) => {
  return (
    <FormItem message={errorMessage} label={label} name={name}>
      <Input.Password size={size} placeholder={placeholder} />
    </FormItem>
  );
};

export default PasswordInput;
